import React from 'react'
import styled from 'styled-components'

// Constants
import { colors } from '../../../_constants/colors'

// Colors
const { MATERIAL_RED_LIGHT_50 } = colors

export const S_CellErrorIndicator = styled.div`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 10px 10px 0;
  border-color: transparent ${MATERIAL_RED_LIGHT_50} transparent transparent;
`

// Params are - onMouseOver , onMouseLeave
export const CellErrorIndicator = (props) => {
  return <S_CellErrorIndicator {...props} />
}
